// Where does a `cyborg:typing_broadcast` belong — a thread, or the main surface?
//
// THE BUG THIS EXISTS FOR: @-mentioning a cybo at the top level of a channel
// showed NO "is typing…" indicator at all while it genuinely worked. The frame
// arrived, correct and on time; app.svelte.ts's client.on("typing", …) threw it
// away.
//
// It threw it away because `parentId` carries TWO different meanings depending on
// who sent the frame:
//   • a HUMAN composer  → "I am typing INSIDE this thread"       (thread-only)
//   • a CYBO's thinking → "this turn's reply will thread HERE"    (NOT thread-only)
// and for a top-level mention that second one is the ask's OWN message id
// (resolveMentionWakeParentId / CYBORG-794 — the reply threads beneath the ask).
// So the handler's `if (event.parentId) { …; return; }` read a channel-level turn
// as somebody else's thread and returned before ever reaching the channel branch.
//
// The server knows the difference (isInThreadWake: `parentId !== messageId`) and
// now says so on the wire. This is the client half: route on the declared intent,
// fall back to the historical rule when it isn't declared.
//
// Extracted as a pure module — rather than left inline in the handler — for the
// same reason channel-message-active.ts was: app.svelte.ts registers a live client
// and window/document listeners at module load, so it cannot be imported under
// vitest and anything decided inside it is untestable. See typing-scope.test.ts.
export function typingIsThreadScoped(event: {
  parentId?: string | null;
  threadScoped?: boolean | null;
}): boolean {
  // No thread root at all → plain channel/DM typing, unchanged.
  if (!event.parentId) return false;
  // An explicit server verdict wins. Only a literal `false` widens the scope, so
  // an older daemon (field absent) or a human composer (never sets it) keeps the
  // pre-existing "parentId means thread" behaviour byte-for-byte.
  return event.threadScoped !== false;
}
